import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import type {
  ActionButton,
  ElementSource,
  ObjectDto,
} from '@bizzdesign/shared/models';
import { AppliedFiltersComponent } from '@bizzdesign/feature-search';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { SearchbarComponent } from '@bizzdesign/ui-searchbar';
import { ActionButtonDirective } from '@bizzdesign/shared/directives';
import { ContentOverviewObjectsListComponent } from '../content-overview-objects-list/content-overview-objects-list.component';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { TabsModule } from 'primeng/tabs';
import { segment } from '@bizzdesign/styles';
import type { FilterItem } from '@bizzdesign/data-access-search';
import { BadgeComponent } from '@bizzdesign/ui-badge';
import { TranslateActionButtonPipe } from '@bizzdesign/shared/pipes';

export enum ContentOverviewTab {
  CONTENT = 0,
  SOURCE = 1,
}

@Component({
  selector: 'bd-content-overview',
  templateUrl: './content-overview.component.html',
  styleUrls: ['./content-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedI18nModule,
    ButtonModule,
    DividerModule,
    AccordionModule,
    BadgeComponent,
    ContentOverviewObjectsListComponent,
    AsyncPipe,
    NgTemplateOutlet,
    TabsModule,
    TranslateActionButtonPipe,
    ActionButtonDirective,
    AppliedFiltersComponent,
    SearchbarComponent,
  ],
})
export class ContentOverviewComponent {
  readonly tab = input<ContentOverviewTab>(ContentOverviewTab.CONTENT);
  readonly appliedFilters = input<FilterItem[] | undefined>(undefined);
  readonly sourceQuery = input<ElementSource | undefined>(undefined);
  readonly objectsList = input<ObjectDto[] | undefined>(undefined);
  readonly loading = input(false);

  readonly close = output<boolean>();
  readonly contentRefresh = output<void>();

  readonly tabsDt = segment;
  readonly ContentOverviewTab = ContentOverviewTab;

  readonly searchTerm = computed(() => this.sourceQuery()?.searchTerm);
  readonly selectedIds = computed(() => this.sourceQuery()?.selectedIds);
  readonly objects$ = computed(() => this.sourceQuery()?.objects$);
  readonly refreshActionButton = computed(
    (): ActionButton => ({
      labelKey: 'objectsOverview.sourceTabRefreshContentLabel',
      tScope: 'featureHighcharts',
      type: 'tertiary',
      loading: this.loading(),
      onClick: () => this.refreshContent(),
    }),
  );

  private refreshContent() {
    this.contentRefresh.emit();
  }
}
